import React from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import VideoCourseImage from "../assets/images/video-course.jpg";
import VideoTestimonial from "../components/Frontend/VideoPTETestimonial";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import API from "../api";
import { store } from "store/index";
import { setAlert } from "action/index";
import { getCountryForTimezone } from "countries-and-timezones";
import BuyBtn from "components/VideoCourse/BuyBtn";
import Plans from "components/VideoCourse/Plans";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import CrackedCodeSlider from "../components/Frontend/Sliders/CrackedCodeSlider";

class VideoCourse extends React.Component {
  constructor(props) {
    super(props);
    this.sectionRef = React.createRef();
    this.state = {
      plans: [],
      corePlans: [],
      country: "AU",
      activeTab: "la_acedemics_tab",
    };
  }

  handleTabClick = (tab) => {
    this.setState({ activeTab: tab });
  };

  scrollToSection = () => {
    const section = this.sectionRef.current;
    if (section) {
      const headerHeight = document.querySelector("header").offsetHeight || 0;
      const sectionTop = section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: sectionTop - headerHeight,
        behavior: "smooth",
      });
    }
  };

  componentDidMount() {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    ReactPixel.init("2474090032742391");
    ReactPixel.init("197333187452630");
    ReactPixel.pageView();
    if (window.location.href.indexOf("#packages") != -1) {
      window.location.hash = "";
      window.location.hash = "packages";
    }
    this.getPackages();
  }

  getPackages() {
    const country = getCountryForTimezone(
      Intl.DateTimeFormat().resolvedOptions().timeZone
    );
    let countryId = "AU";
    if (country && country.id) {
      countryId = country.id;
    }
    const url =
      import.meta.env.VITE_URL_ALT +
      "/api/v2/getPackagesAll?countryId=" +
      countryId;
    API({
      url: url,
      method: "GET",
    }).then((res) => {
      if (res.status === 200) {
        const data = res.data;
        const laPlans = data.la.filter((plan) => plan.is_video !== 0);
        const corePlans = data.core.filter((plan) => plan.is_video !== 0);
        this.setState({ plans: laPlans, corePlans, country: res.data.country });
      } else {
        store.dispatch(
          setAlert({ flag: true, type: 2, message: "Something went wrong." })
        );
      }
    });
  }

  render() {
    const CardsSlider = {
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      adaptiveHeight: true,
      autoplaySpeed: 5000,
    };
    return (
      <React.Fragment>
        <Helmet>
          <title>Language Academy</title>
        </Helmet>
        <Header />
        <div className="innerPage">
          <div className="banner-section noc-banner">
            <div className="container">
              <div className="row">
                <div className="banner-content">
                  <h1 className="primary-heading dark-blue-color">
                    <span className="wpl-badge pte-naati-badge text-white">
                      UNLOCK THE SECRETS
                    </span>
                    <br className="d-block" />
                    <span className="fw-700">
                      OF A 12-TIME PTE <br className="d-block d-md-none" /> PERFECT SCORER
                    </span>
                    <br className="d-block" />
                    VARUN DHAWAN'S EXCLUSIVE{" "}
                    <br className="d-none d-md-block" /> VIDEO COURSE AVAILABLE
                    ONLY <br className="d-none d-md-block" /> TO GOLD MEMBERS
                  </h1>
                  <p className="sub-title">
                    Learn from the expert who scored perfect 90 in PTE{" "}
                    <br className="d-none d-md-block" /> Academic 12 times and
                    has guided 50,000+ students to success
                  </p>
                  <div className="iframe-video-outer position-relative">
                    <div className="banner-img-wrapper">
                      <img
                        className="banner-img"
                        src="/images/web-new-images/banners/video-courses-banner.png"
                        alt="LA"
                      />
                    </div>
                    <img
                      className="emoji1 position-absolute"
                      src="/images/web-new-images/emojis/emoji-1.png"
                      alt="LA"
                    />
                    <img
                      className="emoji2 position-absolute"
                      src="/images/web-new-images/emojis/emoji-2.png"
                      alt="LA"
                    />
                    <img
                      className="emoji3 position-absolute"
                      src="/images/web-new-images/emojis/emoji-3.png"
                      alt="LA"
                    />
                    <img
                      className="emoji4 position-absolute"
                      src="/images/web-new-images/emojis/emoji-4.png"
                      alt="LA"
                    />
                  </div>
                  <div className="light-blue-box">
                    Unlock your PTE potential with our comprehensive video
                    course, featuring proven strategies, expert insights, and
                    step-by-step guidance from Australia's most successful PTE
                    trainer. <br />
                    <br /> Available exclusively with our Gold package - the
                    complete preparation system that transforms your PTE
                    performance.
                  </div>
                  <Link className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                      UPGRADE TO GOLD PACKAGE TODAY
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="vc-video-course">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <h2 className="primary-heading text-center fw-700">
                    WHAT IS THE <br /> LANGUAGE ACADEMY <br />
                    <span className="wpl-badge text-white">
                      PTE VIDEO COURSE?
                    </span>
                  </h2>
                </div>
                <div className="col-md-6">
                  <div className="content-card">
                    <h2>Why This Course Changes Everything</h2>
                    <ul>
                      <li>
                        <h4>
                          <span className="circle"></span> Expert Proven
                        </h4>
                        <p>
                          Created by someone who has mastered the exam at the
                          highest level
                        </p>
                      </li>
                      <li>
                        <h4>
                          <span className="circle"></span> Results Driven
                        </h4>
                        <p>
                          Results Driven Strategies tested and refined through
                          50,000+ student successes
                        </p>
                      </li>
                      <li>
                        <h4>
                          <span className="circle"></span> Comprehensive
                        </h4>
                        <p>Every PTE task covered in exhaustive detail</p>
                      </li>
                      <li>
                        <h4>
                          <span className="circle"></span> Exclusive
                        </h4>
                        <p>Only available to Gold package subscribers</p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="vc-video-content">
                    <h3>
                      The most comprehensive PTE training available anywhere,
                      created by Australia's #1 PTE expert.
                    </h3>
                    <p className="sub-title">
                      Our exclusive PTE Video Course represents over 6 years of
                      teaching excellence and real-world exam mastery, condensed
                      into the ultimate learning experience.
                      <br />
                      <br />
                      Developed personally by Varun Dhawan - the only trainer to
                      achieve a perfect 90 score in PTE Academic 12 times - this
                      course reveals the exact strategies, techniques, and
                      insider knowledge that have helped over 50,000 students
                      achieve their target scores.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row align-items-center vc-bottom-row">
                <div className="col-md-8">
                  <div className="light-blue-box p-3">
                    This isn't just another video course - it's your direct
                    access to the mind of PTE's most successful trainer.
                  </div>
                </div>
                <div className="col-md-4 text-center text-md-end">
                  <Link className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                      START YOUR TRANSFORMATION
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="pc-why-choose vc-why">
            <div className="container">
              <div className="row why-most-second-row">
                <div className="col-lg-6 why-most-content">
                  <h2 className="primary-heading fw-700">
                    Why
                    <br />
                    <span className="wpl-badge text-white">VARUN DHAWAN'S</span>
                    <br />
                    VIDEO COURSE IS <br /> THE GAME-CHANGER <br /> YOU NEED
                  </h2>
                  <h4 className="sub-sub-title my-4">
                    When you learn from the best, <br className="d-none d-md-block" /> there's no room for error.
                  </h4>
                  <p className="sub-title">
                    Most PTE courses are taught by instructors who have simply
                    passed the exam. Varun Dhawan has conquered it - achieving
                    the maximum possible score not once, but 12 times.
                    <br />
                    <br />
                    This course doesn't just teach PTE strategies - it reveals
                    the mindset, approach, and precise techniques of someone who
                    has mastered every aspect of the exam.
                  </p>
                  <br />
                  <Link className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                      UNLOCK VARUN'S EXPERTISE
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </span>
                  </Link>
                </div>
                <div className="col-lg-6">
                  <div className="why-most-list">
                    <ul>
                      <li className="list1">
                        <span className="list-counting">
                          <svg
                            width="30"
                            height="31"
                            viewBox="0 0 30 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.9991 28.2629C21.872 28.2629 27.4436 22.6913 27.4436 15.8185C27.4436 8.94559 21.872 3.37402 14.9991 3.37402C8.12626 3.37402 2.55469 8.94559 2.55469 15.8185C2.55469 22.6913 8.12626 28.2629 14.9991 28.2629Z"
                              stroke="#7F56D9"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M14.9991 23.2851C19.1229 23.2851 22.4658 19.9422 22.4658 15.8185C22.4658 11.6947 19.1229 8.3518 14.9991 8.3518C10.8754 8.3518 7.53247 11.6947 7.53247 15.8185C7.53247 19.9422 10.8754 23.2851 14.9991 23.2851Z"
                              stroke="#7F56D9"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M14.9991 18.3074C16.3737 18.3074 17.488 17.193 17.488 15.8185C17.488 14.4439 16.3737 13.3296 14.9991 13.3296C13.6246 13.3296 12.5102 14.4439 12.5102 15.8185C12.5102 17.193 13.6246 18.3074 14.9991 18.3074Z"
                              stroke="#7F56D9"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>EXPERT INSTRUCTION</h3>
                          <p>
                            Learn from 6+ years of teaching excellence and
                            unparalleled PTE mastery. Varun's personal journey
                            from student to perfect scorer to Australia's most
                            trusted PTE trainer.
                          </p>
                        </div>
                      </li>
                      <li className="list2">
                        <span className="list-counting">
                          <svg
                            width="30"
                            height="31"
                            viewBox="0 0 30 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.86008 20.1242L8.77908 28.2629L14.4891 24.8369C14.6753 24.7252 14.7684 24.6693 14.8678 24.6475C14.9558 24.6282 15.0468 24.6282 15.1348 24.6475C15.2342 24.6693 15.3273 24.7252 15.5135 24.8369L21.2235 28.2629L20.1432 20.1206M20.5091 6.17263C20.7013 6.63745 21.0702 7.00693 21.5347 7.19982L23.1635 7.87454C23.6284 8.06709 23.9977 8.43642 24.1902 8.90128C24.3828 9.36614 24.3828 9.88845 24.1902 10.3533L23.516 11.981C23.3234 12.4461 23.3231 12.9689 23.5166 13.4338L24.1897 15.061C24.2851 15.2913 24.3343 15.5381 24.3343 15.7873C24.3344 16.0366 24.2853 16.2834 24.1899 16.5136C24.0945 16.7439 23.9547 16.9531 23.7784 17.1293C23.6022 17.3055 23.3929 17.4453 23.1626 17.5406L21.535 18.2148C21.0702 18.407 20.7007 18.7759 20.5078 19.2405L19.8331 20.8694C19.6406 21.3342 19.2713 21.7036 18.8064 21.8961C18.3416 22.0887 17.8193 22.0887 17.3544 21.8961L15.7268 21.2219C15.2619 21.0298 14.7398 21.0302 14.2752 21.223L12.6464 21.8967C12.1818 22.0888 11.66 22.0887 11.1955 21.8963C10.731 21.7039 10.3619 21.335 10.1693 20.8706L9.49437 19.2412C9.30218 18.7764 8.93328 18.4069 8.46876 18.214L6.83992 17.5393C6.37528 17.3469 6.00607 16.9778 5.81346 16.5132C5.62084 16.0486 5.62058 15.5265 5.81273 15.0617L6.48694 13.434C6.67901 12.9691 6.67861 12.447 6.48584 11.9824L5.81261 10.3524C5.71716 10.1221 5.66801 9.87532 5.66797 9.62608C5.66793 9.37684 5.717 9.13003 5.81238 8.89976C5.90775 8.66949 6.04757 8.46027 6.22383 8.28406C6.40009 8.10785 6.60935 7.96809 6.83964 7.87279L8.46731 7.19856C8.93172 7.00653 9.30096 6.63808 9.49399 6.17408L10.1687 4.54518C10.3612 4.08032 10.7305 3.71099 11.1954 3.51844C11.6602 3.32589 12.1825 3.32589 12.6474 3.51844L14.275 4.19266C14.7399 4.38474 15.262 4.38435 15.7266 4.19157L17.3561 3.51948C17.8209 3.32704 18.343 3.32708 18.8078 3.51959C19.2725 3.71211 19.6418 4.08133 19.8344 4.54607L20.5093 6.17545L20.5091 6.17263Z"
                              stroke="#0286FF"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>PROVEN STRATEGIES</h3>
                          <p>
                            Access the exact methods that have consistently
                            delivered 79+ scores. These aren't theoretical
                            approaches - they're battle-tested techniques
                            refined through thousands of successful students.
                          </p>
                        </div>
                      </li>
                      <li className="list3">
                        <span className="list-counting">
                          <svg
                            width="28"
                            height="25"
                            viewBox="0 0 28 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.9991 24.0182L13.8746 23.8314C13.0102 22.5347 12.578 21.8864 12.0069 21.417C11.5014 21.0015 10.9188 20.6898 10.2927 20.4996C9.5854 20.2848 8.8062 20.2848 7.2478 20.2848H5.53691C4.143 20.2848 3.44605 20.2848 2.91364 20.0136C2.44533 19.7749 2.06458 19.3942 1.82596 18.9259C1.55469 18.3935 1.55469 17.6965 1.55469 16.3026V5.60039C1.55469 4.20648 1.55469 3.50952 1.82596 2.97712C2.06458 2.50881 2.44533 2.12805 2.91364 1.88944C3.44605 1.61816 4.143 1.61816 5.53691 1.61816H6.03469C8.82251 1.61816 10.2164 1.61816 11.2812 2.16071C12.2178 2.63795 12.9794 3.39945 13.4566 4.33608C13.9991 5.40088 13.9991 6.79479 13.9991 9.58261M13.9991 24.0182V9.58261M13.9991 24.0182L14.1236 23.8314C14.9881 22.5347 15.4203 21.8864 15.9914 21.417C16.4969 21.0015 17.0794 20.6898 17.7056 20.4996C18.4129 20.2848 19.1921 20.2848 20.7505 20.2848H22.4614C23.8553 20.2848 24.5522 20.2848 25.0846 20.0136C25.5529 19.7749 25.9337 19.3942 26.1723 18.9259C26.4436 18.3935 26.4436 17.6965 26.4436 16.3026V5.60039C26.4436 4.20648 26.4436 3.50952 26.1723 2.97712C25.9337 2.50881 25.5529 2.12805 25.0846 1.88944C24.5522 1.61816 23.8553 1.61816 22.4614 1.61816H21.9636C19.1758 1.61816 17.7819 1.61816 16.717 2.16071C15.7804 2.63795 15.0189 3.39945 14.5417 4.33608C13.9991 5.40088 13.9991 6.79479 13.9991 9.58261"
                              stroke="#94C23C"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>COMPREHENSIVE COVERAGE</h3>
                          <p>
                            Master every single PTE task with detailed video
                            tutorials that leave nothing to chance. From basic
                            understanding to advanced optimization techniques.
                          </p>
                        </div>
                      </li>
                      <li className="list4">
                        <span className="list-counting">
                          <svg
                            width="20"
                            height="25"
                            viewBox="0 0 20 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.0002 14.0626V6.59594M6.26684 10.3293H13.7335M18.7113 24.0182V7.5915C18.7113 5.50064 18.7113 4.4552 18.3044 3.6566C17.9465 2.95413 17.3753 2.383 16.6729 2.02507C15.8742 1.61816 14.8288 1.61816 12.738 1.61816H7.2624C5.17153 1.61816 4.1261 1.61816 3.3275 2.02507C2.62503 2.383 2.0539 2.95413 1.69597 3.6566C1.28906 4.4552 1.28906 5.50064 1.28906 7.5915V24.0182L10.0002 19.0404L18.7113 24.0182Z"
                              stroke="#FFB02C"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>EXCLUSIVE ACCESS</h3>
                          <p>
                            Available only with our Gold package, ensuring you
                            receive the highest caliber instruction reserved for
                            our most committed students.
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="why-choosing-section vc-master-aspect">
            <div className="container">
              <div className="row">
                <h2 className="primary-heading text-center fw-700">
                  <span className="wpl-badge gold-badge text-white">
                    MASTER EVERY ASPECT
                  </span>
                  <br />
                  OF THE PTE EXAM
                </h2>
                <p className="sub-heading text-center fw-600">
                  Complete mastery across all four skills - the way only a
                  12-time perfect scorer can teach.
                </p>
                <div className="feature-cards four-cards d-none d-md-grid">
                  <div className="feature-card card1">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.7479 5.29387C21.1652 7.26411 22 9.68151 22 12.2939C22 14.9062 21.1652 17.3236 19.7479 19.2939M15.7453 8.29387C16.5362 9.42771 17 10.8066 17 12.2939C17 13.7811 16.5362 15.16 15.7453 16.2939M9.63432 5.65956L6.46863 8.82524C6.29568 8.99819 6.2092 9.08467 6.10828 9.14651C6.01881 9.20134 5.92127 9.24175 5.81923 9.26624C5.70414 9.29387 5.58185 9.29387 5.33726 9.29387H3.6C3.03995 9.29387 2.75992 9.29387 2.54601 9.40287C2.35785 9.49874 2.20487 9.65172 2.10899 9.83988C2 10.0538 2 10.3338 2 10.8939V13.6939C2 14.2539 2 14.534 2.10899 14.7479C2.20487 14.936 2.35785 15.089 2.54601 15.1849C2.75992 15.2939 3.03995 15.2939 3.6 15.2939H5.33726C5.58185 15.2939 5.70414 15.2939 5.81923 15.3215C5.92127 15.346 6.01881 15.3864 6.10828 15.4412C6.2092 15.5031 6.29568 15.5895 6.46863 15.7625L9.63431 18.9282C10.0627 19.3566 10.2769 19.5708 10.4608 19.5852C10.6203 19.5978 10.7763 19.5332 10.8802 19.4115C11 19.2712 11 18.9683 11 18.3625V6.22524C11 5.61943 11 5.31652 10.8802 5.17626C10.7763 5.05455 10.6203 4.98996 10.4608 5.00252C10.2769 5.01699 10.0627 5.23118 9.63432 5.65956Z"
                            stroke="#7F56D9"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <h3>SPEAKING MASTERY</h3>
                    <ul>
                      <li>
                        <h4>
                          <span className="circle"></span> What You'll Learn
                        </h4>
                        <p>
                          Pronunciation perfection, fluency optimization, and
                          content delivery that maximizes scoring
                        </p>
                      </li>
                      <li>
                        <h4>
                          <span className="circle"></span> Varun's Approach
                        </h4>
                        <p>
                          AI-tested pronunciation techniques,
                          confidence-building exercises, and the psychological
                          preparation that eliminates speaking anxiety
                        </p>
                      </li>
                    </ul>
                  </div>
                  <div className="feature-card card2">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21 18.2939V12.2939C21 7.32338 16.9706 3.29395 12 3.29395C7.02944 3.29395 3 7.32338 3 12.2939V18.2939M5.5 21.2939C4.11929 21.2939 3 20.1747 3 18.7939V16.7939C3 15.4132 4.11929 14.2939 5.5 14.2939C6.88071 14.2939 8 15.4132 8 16.7939V18.7939C8 20.1747 6.88071 21.2939 5.5 21.2939ZM18.5 21.2939C17.1193 21.2939 16 20.1747 16 18.7939V16.7939C16 15.4132 17.1193 14.2939 18.5 14.2939C19.8807 14.2939 21 15.4132 21 16.7939V18.7939C21 20.1747 19.8807 21.2939 18.5 21.2939Z"
                            stroke="#94C23C"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <h3>LISTENING EXCELLENCE</h3>
                    <ul>
                      <li>
                        <h4>
                          <span className="circle"></span> What You'll Learn
                        </h4>
                        <p>
                          Advanced comprehension strategies, note-taking
                          systems, and accent adaptation techniques
                        </p>
                      </li>
                      <li>
                        <h4>
                          <span className="circle"></span> Varun's Approach
                        </h4>
                        <p>
                          Active listening protocols, key information
                          identification, and the concentration methods used by
                          top scorers
                        </p>
                      </li>
                    </ul>
                  </div>
                  <div className="feature-card card3">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 21.2939L11.8999 21.1439C11.2053 20.1019 10.858 19.5809 10.3991 19.2038C9.99286 18.8699 9.52476 18.6194 9.02161 18.4665C8.45325 18.2939 7.82711 18.2939 6.57482 18.2939H5.2C4.07989 18.2939 3.51984 18.2939 3.09202 18.076C2.71569 17.8842 2.40973 17.5783 2.21799 17.2019C2 16.7741 2 16.2141 2 15.0939V6.49394C2 5.37384 2 4.81379 2.21799 4.38596C2.40973 4.00964 2.71569 3.70368 3.09202 3.51193C3.51984 3.29395 4.07989 3.29395 5.2 3.29395H5.6C7.84021 3.29395 8.96031 3.29395 9.81596 3.72992C10.5686 4.11341 11.1805 4.72533 11.564 5.47798C12 6.33363 12 7.45374 12 9.69395M12 21.2939V9.69395M12 21.2939L12.1001 21.1439C12.7947 20.1019 13.142 19.5809 13.6009 19.2038C14.0071 18.8699 14.4752 18.6194 14.9784 18.4665C15.5467 18.2939 16.1729 18.2939 17.4252 18.2939H18.8C19.9201 18.2939 20.4802 18.2939 20.908 18.076C21.2843 17.8842 21.5903 17.5783 21.782 17.2019C22 16.7741 22 16.2141 22 15.0939V6.49394C22 5.37384 22 4.81379 21.782 4.38596C21.5903 4.00964 21.2843 3.70368 20.908 3.51193C20.4802 3.29395 19.9201 3.29395 18.8 3.29395H18.4C16.1598 3.29395 15.0397 3.29395 14.184 3.72992C13.4314 4.11341 12.8195 4.72533 12.436 5.47798C12 6.33363 12 7.45374 12 9.69395"
                            stroke="#0286FF"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <h3>READING DOMINATION</h3>
                    <ul>
                      <li>
                        <h4>
                          <span className="circle"></span> What You'll Learn
                        </h4>
                        <p>
                          Speed reading with comprehension, passage analysis,
                          and time management mastery
                        </p>
                      </li>
                      <li>
                        <h4>
                          <span className="circle"></span> Varun's Approach
                        </h4>
                        <p>
                          Strategic reading patterns, vocabulary optimization,
                          and the systematic approach to complex texts
                        </p>
                      </li>
                    </ul>
                  </div>
                  <div className="feature-card card4">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13 6.29379L6.50182 7.59343C6.13883 7.66603 5.95733 7.70233 5.80952 7.7906C5.67886 7.86863 5.56772 7.97546 5.4846 8.10295C5.39057 8.24716 5.34714 8.42708 5.26028 8.78693L2 22.2938M2 22.2938L15.5069 19.0335C15.8667 18.9467 16.0466 18.9032 16.1908 18.8092C16.3183 18.7261 16.4252 18.6149 16.5032 18.4843C16.5915 18.3365 16.6278 18.155 16.7004 17.792L18 11.2938M2 22.2938L9.586 14.7078M20.8686 8.16242L16.1314 3.42517C15.7354 3.02915 15.5373 2.83114 15.309 2.75695C15.1082 2.69169 14.8918 2.69169 14.691 2.75695C14.4627 2.83114 14.2646 3.02915 13.8686 3.42517L13.1314 4.16242C12.7354 4.55844 12.5373 4.75645 12.4632 4.98478C12.3979 5.18562 12.3979 5.40197 12.4632 5.60281C12.5373 5.83114 12.7354 6.02915 13.1314 6.42516L17.8686 11.1624C18.2646 11.5584 18.4627 11.7564 18.691 11.8306C18.8918 11.8959 19.1082 11.8959 19.309 11.8306C19.5373 11.7564 19.7354 11.5584 20.1314 11.1624L20.8686 10.4252C21.2646 10.0291 21.4627 9.83114 21.5368 9.60281C21.6021 9.40197 21.6021 9.18562 21.5368 8.98478C21.4627 8.75645 21.2646 8.55844 20.8686 8.16242ZM11 11.2938C12.1046 11.2938 13 12.1892 13 13.2938C13 14.3984 12.1046 15.2938 11 15.2938C9.89543 15.2938 9 14.3984 9 13.2938C9 12.1892 9.89543 11.2938 11 11.2938Z"
                            stroke="#FFB02C"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <h3>WRITING PERFECTION</h3>
                    <ul>
                      <li>
                        <h4>
                          <span className="circle"></span> What You'll Learn
                        </h4>
                        <p>
                          Essay structuring, grammar excellence, and response
                          optimization for maximum scoring
                        </p>
                      </li>
                      <li>
                        <h4>
                          <span className="circle"></span> Varun's Approach
                        </h4>
                        <p>
                          Varun's Approach Template mastery, idea development
                          systems, and the writing methodology that guarantees
                          high scores
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Mobile HTML */}
                <div className="slider-dot-arrow d-block d-md-none mobile-slider">
                  <Slider {...CardsSlider} className="feature-cards four-cards">
                    <div className="feature-card card1">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19.7479 5.29387C21.1652 7.26411 22 9.68151 22 12.2939C22 14.9062 21.1652 17.3236 19.7479 19.2939M15.7453 8.29387C16.5362 9.42771 17 10.8066 17 12.2939C17 13.7811 16.5362 15.16 15.7453 16.2939M9.63432 5.65956L6.46863 8.82524C6.29568 8.99819 6.2092 9.08467 6.10828 9.14651C6.01881 9.20134 5.92127 9.24175 5.81923 9.26624C5.70414 9.29387 5.58185 9.29387 5.33726 9.29387H3.6C3.03995 9.29387 2.75992 9.29387 2.54601 9.40287C2.35785 9.49874 2.20487 9.65172 2.10899 9.83988C2 10.0538 2 10.3338 2 10.8939V13.6939C2 14.2539 2 14.534 2.10899 14.7479C2.20487 14.936 2.35785 15.089 2.54601 15.1849C2.75992 15.2939 3.03995 15.2939 3.6 15.2939H5.33726C5.58185 15.2939 5.70414 15.2939 5.81923 15.3215C5.92127 15.346 6.01881 15.3864 6.10828 15.4412C6.2092 15.5031 6.29568 15.5895 6.46863 15.7625L9.63431 18.9282C10.0627 19.3566 10.2769 19.5708 10.4608 19.5852C10.6203 19.5978 10.7763 19.5332 10.8802 19.4115C11 19.2712 11 18.9683 11 18.3625V6.22524C11 5.61943 11 5.31652 10.8802 5.17626C10.7763 5.05455 10.6203 4.98996 10.4608 5.00252C10.2769 5.01699 10.0627 5.23118 9.63432 5.65956Z"
                              stroke="#7F56D9"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                      <h3>SPEAKING MASTERY</h3>
                      <ul>
                        <li>
                          <h4>
                            <span className="circle"></span> What You'll Learn
                          </h4>
                          <p>
                            Pronunciation perfection, fluency optimization, and
                            content delivery that maximizes scoring
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Varun's Approach
                          </h4>
                          <p>
                            AI-tested pronunciation techniques,
                            confidence-building exercises, and the psychological
                            preparation that eliminates speaking anxiety
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="feature-card card2">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21 18.2939V12.2939C21 7.32338 16.9706 3.29395 12 3.29395C7.02944 3.29395 3 7.32338 3 12.2939V18.2939M5.5 21.2939C4.11929 21.2939 3 20.1747 3 18.7939V16.7939C3 15.4132 4.11929 14.2939 5.5 14.2939C6.88071 14.2939 8 15.4132 8 16.7939V18.7939C8 20.1747 6.88071 21.2939 5.5 21.2939ZM18.5 21.2939C17.1193 21.2939 16 20.1747 16 18.7939V16.7939C16 15.4132 17.1193 14.2939 18.5 14.2939C19.8807 14.2939 21 15.4132 21 16.7939V18.7939C21 20.1747 19.8807 21.2939 18.5 21.2939Z"
                              stroke="#94C23C"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                      <h3>LISTENING EXCELLENCE</h3>
                      <ul>
                        <li>
                          <h4>
                            <span className="circle"></span> What You'll Learn
                          </h4>
                          <p>
                            Advanced comprehension strategies, note-taking
                            systems, and accent adaptation techniques
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Varun's Approach
                          </h4>
                          <p>
                            Active listening protocols, key information
                            identification, and the concentration methods used
                            by top scorers
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="feature-card card3">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 21.2939L11.8999 21.1439C11.2053 20.1019 10.858 19.5809 10.3991 19.2038C9.99286 18.8699 9.52476 18.6194 9.02161 18.4665C8.45325 18.2939 7.82711 18.2939 6.57482 18.2939H5.2C4.07989 18.2939 3.51984 18.2939 3.09202 18.076C2.71569 17.8842 2.40973 17.5783 2.21799 17.2019C2 16.7741 2 16.2141 2 15.0939V6.49394C2 5.37384 2 4.81379 2.21799 4.38596C2.40973 4.00964 2.71569 3.70368 3.09202 3.51193C3.51984 3.29395 4.07989 3.29395 5.2 3.29395H5.6C7.84021 3.29395 8.96031 3.29395 9.81596 3.72992C10.5686 4.11341 11.1805 4.72533 11.564 5.47798C12 6.33363 12 7.45374 12 9.69395M12 21.2939V9.69395M12 21.2939L12.1001 21.1439C12.7947 20.1019 13.142 19.5809 13.6009 19.2038C14.0071 18.8699 14.4752 18.6194 14.9784 18.4665C15.5467 18.2939 16.1729 18.2939 17.4252 18.2939H18.8C19.9201 18.2939 20.4802 18.2939 20.908 18.076C21.2843 17.8842 21.5903 17.5783 21.782 17.2019C22 16.7741 22 16.2141 22 15.0939V6.49394C22 5.37384 22 4.81379 21.782 4.38596C21.5903 4.00964 21.2843 3.70368 20.908 3.51193C20.4802 3.29395 19.9201 3.29395 18.8 3.29395H18.4C16.1598 3.29395 15.0397 3.29395 14.184 3.72992C13.4314 4.11341 12.8195 4.72533 12.436 5.47798C12 6.33363 12 7.45374 12 9.69395"
                              stroke="#0286FF"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                      <h3>READING DOMINATION</h3>
                      <ul>
                        <li>
                          <h4>
                            <span className="circle"></span> What You'll Learn
                          </h4>
                          <p>
                            Speed reading with comprehension, passage analysis,
                            and time management mastery
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Varun's Approach
                          </h4>
                          <p>
                            Strategic reading patterns, vocabulary optimization,
                            and the systematic approach to complex texts
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="feature-card card4">
                      <div className="rounded-circle">
                        <div className="img-wrapper">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13 6.29379L6.50182 7.59343C6.13883 7.66603 5.95733 7.70233 5.80952 7.7906C5.67886 7.86863 5.56772 7.97546 5.4846 8.10295C5.39057 8.24716 5.34714 8.42708 5.26028 8.78693L2 22.2938M2 22.2938L15.5069 19.0335C15.8667 18.9467 16.0466 18.9032 16.1908 18.8092C16.3183 18.7261 16.4252 18.6149 16.5032 18.4843C16.5915 18.3365 16.6278 18.155 16.7004 17.792L18 11.2938M2 22.2938L9.586 14.7078M20.8686 8.16242L16.1314 3.42517C15.7354 3.02915 15.5373 2.83114 15.309 2.75695C15.1082 2.69169 14.8918 2.69169 14.691 2.75695C14.4627 2.83114 14.2646 3.02915 13.8686 3.42517L13.1314 4.16242C12.7354 4.55844 12.5373 4.75645 12.4632 4.98478C12.3979 5.18562 12.3979 5.40197 12.4632 5.60281C12.5373 5.83114 12.7354 6.02915 13.1314 6.42516L17.8686 11.1624C18.2646 11.5584 18.4627 11.7564 18.691 11.8306C18.8918 11.8959 19.1082 11.8959 19.309 11.8306C19.5373 11.7564 19.7354 11.5584 20.1314 11.1624L20.8686 10.4252C21.2646 10.0291 21.4627 9.83114 21.5368 9.60281C21.6021 9.40197 21.6021 9.18562 21.5368 8.98478C21.4627 8.75645 21.2646 8.55844 20.8686 8.16242ZM11 11.2938C12.1046 11.2938 13 12.1892 13 13.2938C13 14.3984 12.1046 15.2938 11 15.2938C9.89543 15.2938 9 14.3984 9 13.2938C9 12.1892 9.89543 11.2938 11 11.2938Z"
                              stroke="#FFB02C"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                      <h3>WRITING PERFECTION</h3>
                      <ul>
                        <li>
                          <h4>
                            <span className="circle"></span> What You'll Learn
                          </h4>
                          <p>
                            Essay structuring, grammar excellence, and response
                            optimization for maximum scoring
                          </p>
                        </li>
                        <li>
                          <h4>
                            <span className="circle"></span> Varun's Approach
                          </h4>
                          <p>
                            Varun's Approach Template mastery, idea development
                            systems, and the writing methodology that guarantees
                            high scores
                          </p>
                        </li>
                      </ul>
                    </div>
                  </Slider>
                </div>

                <div className="text-center">
                  <Link to="/auth/register" className="primary-btn">
                    EXPERIENCE COMPLETE PTE MASTERY
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="pte-campus mt-0 vc-pte-campus">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 text-center">
                  <h2 className="primary-heading">
                    <span className="wpl-badge text-white mb-4">
                      WHAT'S INCLUDED
                    </span>
                    <br />
                    IN YOUR VIDEO
                    <br />
                    COURSE ACCESS
                  </h2>
                  <p className="text-uppercase">
                    Every secret, every strategy, every
                    <br />
                    technique - nothing held back.
                  </p>
                  <div className="text-center">
                    <Link to="/auth/register" className="primary-btn">
                      UNLOCK THE COMPLETE SYSTEM
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </Link>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="pte-campus-list mb-0 mt-4 mt-lg-0">
                    <ul>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          DETAILED TASK INSIGHTS
                        </h3>
                        <p>
                          Comprehensive video modules breaking down each PTE
                          task type with surgical precision. Understand not just
                          what to do, but why it works and how to optimize your
                          approach.
                        </p>
                      </li>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          ONE-ON-ONE SESSIONS
                        </h3>
                        <p>
                          Master Varun's personal strategies tailored to each
                          section. These are the exact mental frameworks and
                          tactical approaches he uses to achieve perfect scores
                          consistently.
                        </p>
                      </li>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          VARUN DHAWAN'S PERSONAL EXPERTISE
                        </h3>
                        <p>
                          Access insights and strategies that money can't buy
                          elsewhere - the accumulated wisdom of Australia's most
                          successful PTE practitioner.
                        </p>
                      </li>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          PERFORMANCE OPTIMIZATION
                        </h3>
                        <p>
                          Learn how to identify your weaknesses, optimize your
                          strengths, and calibrate your preparation for maximum
                          score improvement.
                        </p>
                      </li>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          TEST DAY MASTERY
                        </h3>
                        <p>
                          Mental preparation, time management, and the
                          confidence-building techniques that separate good
                          performers from perfect scorers.
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="choice-ielts vc-gold-package">
            <div className="container">
              <div className="row">
                <h2 className="primary-heading text-center fw-700">
                  <span className="wpl-badge gold-badge text-white">
                    THE GOLD PACKAGE
                  </span>
                  <br className="d-block" />
                  YOUR GATEWAY <br /> TO PTE EXCELLENCE
                </h2>
                <div className="plan-cards d-none d-md-flex mb-0">
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>UNLIMITED AI SCORING</h2>
                        <p>
                          Perfect your responses with unlimited access to our
                          advanced AI scoring system across all question types.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>COMPLETE QUESTION BANK</h2>
                        <p>
                          Practice with our comprehensive database of exam
                          questions covering every possible scenario.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>UNLIMITED MOCK TESTS</h2>
                        <p>
                          Take as many sectional, full-length, and comprehensive
                          mock tests as you need to build unshakeable
                          confidence.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>VARUN'S COMPLETE VIDEO COURSE</h2>
                        <p>
                          The crown jewel - exclusive access to the most
                          comprehensive PTE training available anywhere.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>PREMIUM STRATEGY VIDEOS</h2>
                        <p>
                          Access our complete library of advanced strategy
                          videos covering optimization techniques.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>LATEST TEMPLATES & PREDICTIONS</h2>
                        <p>
                          Stay ahead with constantly updated templates and
                          prediction files based on recent exam patterns.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>READING EXPLANATION VIDEOS</h2>
                        <p>
                          Master complex reading tasks with detailed explanation
                          videos that clarify every aspect.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slider-dot-arrow d-block d-md-none mobile-slider">
                  <Slider {...CardsSlider} className="plan-cards">
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>UNLIMITED AI SCORING</h2>
                          <p>
                            Perfect your responses with unlimited access to our
                            advanced AI scoring system across all question
                            types.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>COMPLETE QUESTION BANK</h2>
                          <p>
                            Practice with our comprehensive database of exam
                            questions covering every possible scenario.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>UNLIMITED MOCK TESTS</h2>
                          <p>
                            Take as many sectional, full-length, and
                            comprehensive mock tests as you need to build
                            unshakeable confidence.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>VARUN'S COMPLETE VIDEO COURSE</h2>
                          <p>
                            The crown jewel - exclusive access to the most
                            comprehensive PTE training available anywhere.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>PREMIUM STRATEGY VIDEOS</h2>
                          <p>
                            Access our complete library of advanced strategy
                            videos covering optimization techniques.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>LATEST TEMPLATES & PREDICTIONS</h2>
                          <p>
                            Stay ahead with constantly updated templates and
                            prediction files based on recent exam patterns.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>READING EXPLANATION VIDEOS</h2>
                          <p>
                            Master complex reading tasks with detailed
                            explanation videos that clarify every aspect.
                          </p>
                        </div>
                      </div>
                    </div>
                  </Slider>
                </div>
              </div>
            </div>
          </div>

          <div className="choice-ielts vc-gold-duration">
            <div className="container">
              <div className="row">
                <div className=" vc-gold-duration-header">
                  <h2 className="primary-heading text-center fw-700">
                    CHOOSE YOUR GOLD <br className="d-block" /> PACKAGE DURATION
                  </h2>
                  <p className="sub-title">GOLD PACKAGE OPTIONS</p>
                </div>
                <div className=" vc-gold-duration-list">
                  <div className="list list-one">
                    <h2>Duration</h2>
                    <p>1 Month</p>
                    <p>2 Month</p>
                    <p className="mb-0">3 Month</p>
                  </div>
                  <div className="list list-two">
                    <h2>Savings</h2>
                    <p>Standard</p>
                    <p>30% OFF</p>
                    <p className="mb-0">45% OFF</p>
                  </div>
                  <div className="list list-three">
                    <h2>Price</h2>
                    <div>
                      <p className="price">AUD $89*</p>
                    </div>
                    <div>
                      <p className="price price-one">
                        AUD $119* <span>(BEST SELLER)</span>
                      </p>
                    </div>
                    <div>
                      <p className="price price-two mb-0">
                        AUD $139* <span>(MOST SAVINGS)</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className=" vc-gold-duration-footer">
                  <p>*Auto-renews. Cancel anytime.</p>
                  <Link to="/auth/register" className="primary-btn">
                    UPGRADE TO GOLD NOW
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <CrackedCodeSlider 
          title={`<span className="fw-700">WHAT OUR video</span> <br className="d-block" /><span className="wpl-badge pte-naati-badge text-white">COURSE STUDENTS SAY</span>`}
          subtitle={`Real results from real students who experienced Varun's training.`}  />

          <div className="container">
            <div className="row">
              <div className="text-center">
                <Link to="/auth/register" className="primary-btn">
                  JOIN THOUSANDS OF SUCCESS STORIES
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </Link>
              </div>
            </div>
          </div>

          <div className="naati-mobile-app vc-blue-section">
            <div className="container">
              <div className="row mt-0">
                <div className="col-lg-6">
                  <h2 className="primary-heading fw-700 mb-0">
                    WHY{" "}
                    <br className="d-block d-md-none" />
                    <span className="wpl-badge gold-badge text-white">
                      GOLD PACKAGE
                    </span>
                    <br />
                    STUDENTS ACHIEVE
                    <br />
                    HIGHER SCORES
                  </h2>
                  <p className="sub-title fw-500 my-4 text-center text-md-start">
                    The difference between good preparation{" "}
                    <br className="d-none d-md-block" /> and perfect
                    preparation.
                  </p>
                  <Link className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                      EXPERIENCE THE GOLD DIFFERENCE
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </span>
                  </Link>
                </div>
                <div className="col-lg-6">
                  <div className="why-most-list">
                    <ul>
                      <li className="list10">
                        <span className="list-counting">
                          <svg
                            width="23"
                            height="29"
                            viewBox="0 0 23 29"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.4622 2.15924C11.7977 5.35347 12.095 8.47337 14.1903 11.1372C14.8473 10.408 15.4379 9.75106 16.1049 9.01177C16.1832 9.37137 16.2274 9.61043 16.2877 9.84548C16.5267 10.7676 16.9908 11.5611 17.6136 12.2803C18.6783 13.5118 19.5341 14.8779 20.1569 16.3866C21.2116 18.94 20.8621 21.3568 19.3795 23.6229C18.3951 25.1276 17.0129 26.1863 15.3495 26.8693C15.2049 26.9276 15.0502 26.9597 14.7609 27.0461C15.002 26.6383 15.1807 26.3631 15.3314 26.0758C15.6488 25.4711 15.9662 24.8664 16.2575 24.2497C16.9767 22.7148 16.3098 21.4552 15.4299 20.1393C15.0924 20.7159 14.797 21.2182 14.4314 21.8409C12.991 19.7355 11.5425 17.7949 10.5381 15.5328C10.4838 15.5569 10.4095 15.567 10.3753 15.6072C9.18805 17.0616 8.13134 18.6005 7.5387 20.4005C6.78132 22.7028 7.36995 24.7318 8.87867 26.5499C8.97309 26.6644 9.07555 26.7709 9.21416 26.9236C9.10568 26.9517 9.02934 26.9959 8.96505 26.9818C6.0139 26.3249 3.66343 24.8785 2.56654 21.9133C1.76899 19.7597 1.95381 17.5799 2.64288 15.4324C3.69758 12.1477 5.52975 9.28699 7.62307 6.58897C8.71594 5.1807 9.92332 3.86283 11.0825 2.50678C11.1749 2.3983 11.2934 2.31392 11.4642 2.15723L11.4622 2.15924Z"
                              stroke="#FF6464"
                              strokeWidth="2.48889"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>EXCLUSIVE CONTENT</h3>
                          <p>
                            Access training materials available nowhere else,
                            created by the only trainer to achieve perfect
                            scores 12 times.
                          </p>
                        </div>
                      </li>
                      <li className="list4">
                        <span className="list-counting">
                          <svg
                            width="30"
                            height="31"
                            viewBox="0 0 30 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19.9769 10.6239V6.89056L23.7102 3.15723L24.9546 5.64612L27.4435 6.89056L23.7102 10.6239H19.9769ZM19.9769 10.6239L14.9991 15.6016M27.4436 15.6017C27.4436 22.4746 21.872 28.0461 14.9991 28.0461C8.12626 28.0461 2.55469 22.4746 2.55469 15.6017C2.55469 8.72879 8.12626 3.15723 14.9991 3.15723M21.2214 15.6017C21.2214 19.0381 18.4356 21.8239 14.9991 21.8239C11.5627 21.8239 8.77691 19.0381 8.77691 15.6017C8.77691 12.1652 11.5627 9.37945 14.9991 9.37945"
                              stroke="#FFB02C"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>PRECISION TRAINING</h3>
                          <p>
                            Learn with surgical precision rather than generic
                            advice. Every technique is calibrated for maximum
                            score impact.
                          </p>
                        </div>
                      </li>
                      <li className="list3">
                        <span className="list-counting">
                          <svg
                            width="30"
                            height="31"
                            viewBox="0 0 30 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M26.2008 26.8019H5.79189C5.09494 26.8019 4.74646 26.8019 4.48026 26.6662C4.2461 26.5469 4.05573 26.3565 3.93642 26.1224C3.80078 25.8562 3.80078 25.5077 3.80078 24.8107V4.40186M26.2008 9.37963L19.4381 16.1423C19.1917 16.3887 19.0685 16.512 18.9264 16.5581C18.8014 16.5987 18.6668 16.5987 18.5418 16.5581C18.3998 16.512 18.2766 16.3887 18.0302 16.1423L15.7047 13.8169C15.4583 13.5705 15.3351 13.4473 15.1931 13.4012C15.0681 13.3605 14.9335 13.3605 14.8085 13.4012C14.6664 13.4473 14.5432 13.5705 14.2968 13.8169L8.77856 19.3352M26.2008 9.37963H21.223M26.2008 9.37963V14.3574"
                              stroke="#48A75C"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>PROVEN METHODOLOGY</h3>
                          <p>
                            Follow the exact system that has guided 50,000+
                            students to success, refined through years of
                            teaching excellence.
                          </p>
                        </div>
                      </li>
                      <li className="list6">
                        <span className="list-counting">
                          <svg
                            width="30"
                            height="31"
                            viewBox="0 0 30 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.18059 11.8685H26.825M12.5139 4.40186L10.025 11.8685L15.0028 26.1796L19.9806 11.8685L17.4917 4.40186M15.7676 25.8841L26.9161 12.5059C27.1051 12.2791 27.1996 12.1658 27.2357 12.0392C27.2675 11.9276 27.2675 11.8094 27.2357 11.6978C27.1996 11.5713 27.1051 11.4579 26.9161 11.2312L21.5235 4.76007C21.4138 4.6284 21.359 4.56256 21.2917 4.51523C21.2321 4.4733 21.1656 4.44215 21.0953 4.42322C21.0158 4.40186 20.9301 4.40186 20.7587 4.40186H9.24688C9.07548 4.40186 8.98978 4.40186 8.91037 4.42322C8.84 4.44215 8.77351 4.4733 8.71392 4.51523C8.64666 4.56256 8.5918 4.6284 8.48207 4.76007L3.08948 11.2312C2.90054 11.4579 2.80607 11.5713 2.76997 11.6978C2.73814 11.8094 2.73814 11.9276 2.76997 12.0392C2.80607 12.1658 2.90054 12.2791 3.08948 12.5059L14.238 25.8841C14.5007 26.1993 14.632 26.3569 14.7892 26.4143C14.9271 26.4647 15.0785 26.4647 15.2164 26.4143C15.3736 26.3569 15.505 26.1993 15.7676 25.8841Z"
                              stroke="#0286FF"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>Premium Support</h3>
                          <p>
                            Gold package subscribers receive priority access to
                            updates, new content, and advanced training
                            materials.
                          </p>
                        </div>
                      </li>
                      <li className="list7">
                        <span className="list-counting">
                          <svg
                            width="30"
                            height="31"
                            viewBox="0 0 30 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.86008 19.9074L8.77908 28.0461L14.4891 24.6201C14.6753 24.5084 14.7684 24.4525 14.8678 24.4307C14.9558 24.4114 15.0468 24.4114 15.1348 24.4307C15.2342 24.4525 15.3273 24.5084 15.5135 24.6201L21.2235 28.0461L20.1432 19.9038M20.5091 5.95583C20.7013 6.42066 21.0702 6.79013 21.5347 6.98303L23.1635 7.65774C23.6284 7.85029 23.9977 8.21962 24.1902 8.68448C24.3828 9.14934 24.3828 9.67165 24.1902 10.1365L23.516 11.7642C23.3234 12.2293 23.3231 12.7522 23.5166 13.217L24.1897 14.8442C24.2851 15.0745 24.3343 15.3213 24.3343 15.5705C24.3344 15.8198 24.2853 16.0666 24.1899 16.2968C24.0945 16.5271 23.9547 16.7363 23.7784 16.9125C23.6022 17.0887 23.3929 17.2285 23.1626 17.3238L21.535 17.998C21.0702 18.1902 20.7007 18.5592 20.5078 19.0237L19.8331 20.6526C19.6406 21.1174 19.2713 21.4868 18.8064 21.6793C18.3416 21.8719 17.8193 21.8719 17.3544 21.6793L15.7268 21.0051C15.2619 20.813 14.7398 20.8134 14.2752 21.0062L12.6464 21.6799C12.1818 21.872 11.66 21.8719 11.1955 21.6795C10.731 21.4871 10.3619 21.1182 10.1693 20.6538L9.49437 19.0244C9.30218 18.5596 8.93328 18.1901 8.46876 17.9973L6.83992 17.3225C6.37528 17.1301 6.00607 16.761 5.81346 16.2964C5.62084 15.8318 5.62058 15.3097 5.81273 14.8449L6.48694 13.2172C6.67901 12.7523 6.67861 12.2302 6.48584 11.7656L5.81261 10.1356C5.71716 9.90532 5.66801 9.65853 5.66797 9.40928C5.66793 9.16004 5.717 8.91323 5.81238 8.68296C5.90775 8.45269 6.04757 8.24348 6.22383 8.06726C6.40009 7.89105 6.60935 7.7513 6.83964 7.65599L8.46731 6.98176C8.93172 6.78973 9.30096 6.42128 9.49399 5.95728L10.1687 4.32838C10.3612 3.86352 10.7305 3.49419 11.1954 3.30164C11.6602 3.10909 12.1825 3.10909 12.6474 3.30164L14.275 3.97587C14.7399 4.16795 15.262 4.16755 15.7266 3.97478L17.3561 3.30269C17.8209 3.11024 18.343 3.11028 18.8078 3.3028C19.2725 3.49531 19.6418 3.86453 19.8344 4.32927L20.5093 5.95865L20.5091 5.95583Z"
                              stroke="#FFB02C"
                              strokeWidth="1.86667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <div>
                          <h3>Results Guarantee</h3>
                          <p>
                            Join the 94% of Gold package students who achieve
                            their target scores within their subscription
                            period.
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="container ve-blue-joureny">
              <div className="row">
                <h2 className="primary-heading text-center fw-600">
                  START YOUR JOURNEY TO
                  <br />
                  <span className="wpl-badge  text-white">
                    PTE SUCCESS TODAY
                  </span>
                </h2>
                <h2 className="sub-sub-title text-white fw-500 my-4">
                  Stop settling for average preparation. Demand excellence.
                </h2>
                <p className="sub-title fw-300">
                  The difference between scoring 65 and scoring 90 isn't just
                  practice - it's learning from someone who has mastered the
                  exam at the highest possible level.
                  <br />
                  <br />
                  Varun Dhawan's exclusive video course represents your direct
                  access to perfection. These aren't just lessons - they're the
                  accumulated wisdom of Australia's most successful PTE trainer,
                  distilled into the ultimate learning experience.
                </p>
                <h2 className="comprehensive-title text-white fw-500 mt-4">
                  Your PTE Success Journey Begins Here
                </h2>
                <div className="plan-cards d-none d-md-flex">
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>INSTANT ACCESS</h2>
                        <p>
                          Start learning immediately
                          <br className="d-none s-md-block" />
                          after upgrading to Gold
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>COMPLETE SYSTEM</h2>
                        <p>
                          Everything you need for PTE mastery in one package
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>EXPERT GUIDANCE</h2>
                        <p>Learn from the only 12-time perfect scorer</p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>EXPERT GUIDANCE</h2>
                        <p>Learn from the only 12-time perfect scorer</p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>PROVEN RESULTS</h2>
                        <p>Join 50,000+ successful students</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Mobile HTML */}
                <div className="slider-dot-arrow d-block d-md-none mobile-slider">
                  <Slider {...CardsSlider} className="plan-cards">
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>INSTANT ACCESS</h2>
                          <p>
                            Start learning immediately
                            <br className="d-none s-md-block" />
                            after upgrading to Gold
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>COMPLETE SYSTEM</h2>
                          <p>
                            Everything you need for PTE mastery in one package
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>EXPERT GUIDANCE</h2>
                          <p>Learn from the only 12-time perfect scorer</p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>EXPERT GUIDANCE</h2>
                          <p>Learn from the only 12-time perfect scorer</p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>PROVEN RESULTS</h2>
                          <p>Join 50,000+ successful students</p>
                        </div>
                      </div>
                    </div>
                  </Slider>
                </div>
              </div>
              <div className="row align-items-center ve-blue-bottom">
                <div className="col-lg-7">
                  <p className="sub-title fw-500 text-center text-lg-start">
                    Don't just prepare for PTE. Master it.
                  </p>
                </div>
                <div className="col-lg-5 text-center text-lg-end mt-4 mt-lg-0">
                  <Link className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                      UPGRADE TO GOLD PACKAGE NOW
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="faq-section">
            <div className="container">
              <div className="row">
                <h2 className="secondary-heading text-center">
                  Frequently Asked Questions
                </h2>
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        How is this video course different from other PTE
                        training?
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        This course is created by Varun Dhawan, who has achieved
                        a perfect 90 score in PTE Academic 12 times - something
                        no other trainer can claim. You're learning from proven
                        mastery, not just passing scores.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        Can I access the video course without the Gold package?
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum dolor sit, amet consectetur adipisicing
                        elit. Non, maiores voluptate iste repellat debitis vero
                        nisi cumque nulla aspernatur beatae doloribus facilis
                        cum sapiente nesciunt suscipit vitae sit dolorem autem.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        How long do I have access to the video course?
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Veniam eaque provident dignissimos quos
                        necessitatibus tempora perferendis architecto
                        repellendus ea ex voluptates sed eos iusto in, eveniet
                        voluptatibus, magni ratione ut?
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFour">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        Is the content updated regularly?
                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Veniam eaque provident dignissimos quos
                        necessitatibus tempora perferendis architecto
                        repellendus ea ex voluptates sed eos iusto in, eveniet
                        voluptatibus, magni ratione ut?
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFive">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                        What if I'm not satisfied with the course?
                      </button>
                    </h2>
                    <div
                      id="collapseFive"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFive"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Veniam eaque provident dignissimos quos
                        necessitatibus tempora perferendis architecto
                        repellendus ea ex voluptates sed eos iusto in, eveniet
                        voluptatibus, magni ratione ut?
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingSix">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix"
                        aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                        How much time should I dedicate to the video course?
                      </button>
                    </h2>
                    <div
                      id="collapseSix"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingSix"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Veniam eaque provident dignissimos quos
                        necessitatibus tempora perferendis architecto
                        repellendus ea ex voluptates sed eos iusto in, eveniet
                        voluptatibus, magni ratione ut?
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 text-center mt-4">
                <Link className="primary-btn" to="/auth/register">
                  <span className="btn-inner">
                    UPGRADE TO GOLD PACKAGE TODAY
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}
export default VideoCourse;
